import { generateUUID } from 'shared/helpers/utils/generate-uuid';
import { TableFilterFieldType } from 'common/TableFilter';
import type { TableFilterField } from 'common/TableFilter';

export const regionsFilterFields: TableFilterField[] = [
  {
    key: generateUUID(),
    name: 'name',
    label: 'Название региона',
    type: TableFilterFieldType.INPUT,
  },
];
